import { useEffect } from 'react';
import { useAppSelector } from '../redux/store';
import { useTrackActivity } from './useTrackActivity';
import AsyncStorage from '@react-native-community/async-storage';

/**
 * Hook to track registration events after a successful signup
 * This will only track if the user came from a LiveEvent and had that event stored in the Redux state
 * @returns An object with a trackRegistrationIfNeeded function
 */
export const useRegistrationTracking = () => {
	const { signUpEventId } = useAppSelector(state => state.user);
	const { trackRegistrationEvent } = useTrackActivity();

	/**
	 * Track registration if the user signed up from a LiveEvent
	 * @param identifier Optional identifier (email or other unique ID) to use for tracking
	 */
	const trackRegistrationIfNeeded = async (identifier?: string) => {
		// Only track if there's an event that triggered the registration
		if (signUpEventId) {
			try {
				// If no identifier is provided, try to get the uniqueId from AsyncStorage
				if (!identifier) {
					const uniqueId = await AsyncStorage.getItem('uniqueId');
					// Only use the uniqueId if it's not null
					if (uniqueId) {
						identifier = uniqueId;
					}
				}

				// Track the registration event if we have an identifier
				if (identifier) {
					await trackRegistrationEvent(signUpEventId, identifier);
					console.log(
						'Registration tracked for event:',
						signUpEventId
					);
				} else {
					console.warn(
						'Could not track registration: Missing identifier'
					);
				}
			} catch (error) {
				console.error('Error tracking registration:', error);
			}
		}
	};

	return { trackRegistrationIfNeeded };
};
